"use strict";var e=require("../Object/objectAssign.cjs");exports.createModelOfType=function(t,r){return void 0===r&&(r={}),e.objectAssign(new t,r)};
//# sourceMappingURL=createModelOfType.cjs.map
